import React from 'react'
import Styles from './componentLoader.module.css'
import {Loader} from 'semantic-ui-react'

const ComponentLoader=(props)=>{
    return(
        <div className={Styles.container} {...props}>
            <Loader active/>
        </div>
    )
}

export default ComponentLoader